module.exports = __webpack_public_path__ + "static/media/mmm-provider.6f9b335f.svg";